import { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS } from '../../abi/super-minter.mjs';

async function getTotalMintPriceAndFees(client, { edition, tier, scheduleNum, quantity }) {
  return client.readContract({
    abi: SUPER_MINTER_ABI,
    address: SUPER_MINTER_ADDRESS,
    functionName: "totalPriceAndFees",
    args: [edition, tier, scheduleNum, quantity]
  });
}

export { getTotalMintPriceAndFees };
